import { Controller } from "@hotwired/stimulus"

// 15/10/2026 : écran super-admin des patentes. Choisir un motif prérempli
// recopie son texte dans le champ, où il se retouche ; « Autre » vide le champ
// pour écrire. Les textes vivent dans Workspace::MotifDeRefus, pas ici.
export default class extends Controller {
  static targets = ["choix", "texte"]

  remplir() {
    const option = this.choixTarget.selectedOptions[0]
    this.texteTarget.value = option ? (option.dataset.texte || "") : ""
    this.texteTarget.focus()
  }
}
